<!-- Two the same implementations to allow use of 2 different directives -->
<ng-container *ngIf="!(authStore.isEndUser$ | async)">
  <ng-container *appForCountries="plantOverviewCountries">
    <div class="plant-overview-link-wrapper flex flex-row justify-center items-center">
      <button
        class="link-btn"
        color="primary"
        gtm="onRedirect"
        gtmAction="Plant overview link open"
        gtmCategory="plantOverview"
        gtmLabel="{{ overviewUrl }}"
        mat-raised-button
        data-at-go-to-heating-system-overview-button
        (mousedown)="navigateToHeatingSystemOverview($event)"
      >
        {{ '+INSTALLATIONS.INSTALLATION.PLANT_OVERVIEW_LINK' | translate }}
      </button>
    </div>
  </ng-container>
</ng-container>

<!-- Show for RSA Users (appForCountries always returns false for RSA users) -->
<ng-container *appShowForRsaUser>
  <div class="plant-overview-link-wrapper flex flex-row justify-center items-center">
    <button
      class="link-btn"
      color="primary"
      gtm="onRedirect"
      gtmAction="Plant overview link open"
      gtmCategory="plantOverview"
      gtmLabel="{{ overviewUrl }}"
      mat-raised-button
      data-at-go-to-heating-system-overview-button
      (mousedown)="navigateToHeatingSystemOverview($event)"
    >
      {{ '+INSTALLATIONS.INSTALLATION.PLANT_OVERVIEW_LINK' | translate }}
    </button>
  </div>
</ng-container>
